// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_3p-2";
export var blackBorderOnHover = "_3p-7";
export var cell = "_3p-6";
export var cellContainer = "_3p-3";
export var checked = "_3p-8";
export var disabled = "_3p-5";
export var featuredIconCellContainer = "_3p-9";
export var featuredIconTextContainer = "_3p-b";
export var featuredIconWrapper = "_3p-a";
export var noBorder = "_3p-c";
export var orangeSelectedRow = "_bz-3";
export var overflowableText = "_3p-0";
export var overflowableTextContainer = "_3p-1";
export var row = "_3o-0";
export var rowCheckboxCell = "_3p-4";
export var selectableTable = "_bz-2";